import { COLOR_PALETTE, Text } from '@inflearn/ds-react';

export const GameEntryComment = () => {
  return (
    <Text
      color="white"
      size="sm"
      css={{
        '&:hover': {
          color: COLOR_PALETTE.gray[4],
        },
        '@media(max-width: 1200px)': {
          display: 'none',
        },
      }}
    >
      톱니바퀴 아래, 조용한 문은 호기심에게만 열린다.
    </Text>
  );
};
